<template>
  <div class="lawsifynew_fluid w_100">
    <div class="lawsifynew text_center">
      <div class="tag_list flex_start">
        <div
          v-for="(item, index) in taglist"
          :key="index"
          :class="{ atg_activ: index == tagactive }"
          @click="tagcl(index)"
        >
          {{ item.cat_name }}
        </div>
      </div>

      <div class="ifynewcont between">
        <div class="ify">
          <div class="ify_tit1">精选分类</div>
          <div class="ify_list" v-if="taglist[tagactive]">
            <div class="big_ify" v-for="(item, index) in taglist[tagactive].children" :key="index">
              <div class="big_item_tit">{{item.cat_name}}</div>
              <div class="item flex_start wrap">
                <span v-for="(chitem,chindex) in item.children" :key="chindex" @click="tojjlist(chitem)">{{chitem.cat_name}}</span>
              </div>
            </div>
          </div>
          <div class="ify_mo">查看更多</div>
        </div>
        <div class="ifynew">
          <div class="ifynew_top between">
            <div class="int_left">
              <div
                class="item flex_start"
                v-for="(item, index) in topli.slice(0, 3)"
                :key="index"
                @click="tojump(item)"
              >
                <div class="itemimg">
                  <img :src="item.preview_pic" />
                </div>
                <div class="text">
                  <div class="text1 ellipsis">{{ item.title }}</div>
                  <div class="text2">
                    {{ item.content | toEllipsisFilter(32) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="int_right">
              <div
                class="item flex_start"
                v-for="(item, index) in topli.slice(3)"
                :key="index"
                @click="tojump(item)"
              >
                <div class="time">
                  <div class="time1">
                    {{ item.updated_at.substring(8, 10) }}
                  </div>
                  <div class="time2">{{ item.updated_at.substring(0, 7) }}</div>
                </div>
                <div class="text">
                  {{ item.content | toEllipsisFilter(35) }}
                </div>
              </div>
            </div>
          </div>
          <div class="ifynew_bottom between">
            <div class="inb_l">
              <sub-title text="最近更新" />
              <ul class="inb_llist">
                <li
                  v-for="(item, index) in bomli"
                  :key="index"
                  @click="tojump(item)"
                >
                  <div class="between">
                    <div>{{ item.title }}</div>
                    <div>{{ item.updated_at.substring(5, 10) }}</div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="inb_r">
              <sub-title text="婚姻家庭律师推荐" />
              <law-card class="inb_c" :isudflo="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import subTitle from "views/home/components/subTitle";
import lawCard from "../components/lawCard";
export default {
  components: {
    secTitle,
    subTitle,
    lawCard,
  },
  data: () => ({
    tagactive: 0,
    taglist: [
      { cat_name: "婚姻家庭" },
      { cat_name: "刑事辩护" },
      { cat_name: "交通事故" },
      { cat_name: "合同纠纷" },
      { cat_name: "房产纠纷" },
      { cat_name: "公司法" },
      { cat_name: "知识产权" },
      { cat_name: "债权债务" },
      { cat_name: "劳动纠纷" },
    ],
    topli: [],
    bomli: [],
  }),
  beforeMount() {
    this.getify();
    this.gettopli();
    this.getbomli();
  },
  methods: {
    tagcl(index) {
      this.tagactive = index;

      this.gettopli();
      this.getbomli();
    },
    getify() {
      this.$http.laws.getlawify().then((res) => {
        this.taglist = res.data;
      });
    },
    gettopli() {
      this.$http.laws
        .getnewslist({
          cat_id: this.taglist[this.tagactive].id,
          limit: 6,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this["topli"] = res.data.data;
        });
    },
    getbomli() {
      this.$http.laws
        .getnewslist({
          cat_id: this.taglist[this.tagactive].id,
          limit: 4,
          order: "hot",
          page: 2,
        })
        .then((res) => {
          this["bomli"] = res.data.data;
        });
    },
    tojump(current) {
      this.$router.push({
        path: "/laws/specialdet",
        query: {
          lawonId: current.id,
        },
      });
    },
    tojjlist(item) {
      this.$store.commit("laws/upfljjxx", { name: item.cat_name, id: item.id });
      this.$router.push({
        path: "/laws/speciallist",
      });
    },
  },
};
</script>

<style lang="scss" scope>
.lawsifynew_fluid {
  background-color: #f8f8f8;
  .lawsifynew {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    .tag_list {
      border-bottom: 1px solid #e2e2e2;
      font-size: 18px;
      div {
        cursor: pointer;
        width: 120px;
        color: #c1c1c1;
        height: 40px;
        line-height: 40px;
      }
      .atg_activ {
        color: #fff;
        background: #0465ea;
      }
    }
    .ifynewcont {
      margin-top: 30px;
      align-items: flex-start;
      height: 570px;
      .ify {
        width: 280px;
        height: 100%;
        padding: 35px 18px;
        text-align: left;
        background-color: #ffffff;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        .ify_tit1 {
          display: inline-block;
          font-size: 18px;
          color: #333333;
          border-bottom: 2px solid #0465ea;
          font-weight: bold;
          padding-bottom: 8px;
        }
        // .ify_list {
        //   height: 390px;

        //   span {
        //     float: left;
        //     cursor: pointer;
        //     margin-top: 13px;
        //     margin-right: 16px;
        //     font-size: 12px;
        //     line-height: 12px;
        //     color: #666666;
        //   }
        // }
        .ify_list {
          height: 370px;
          .big_ify {
            .big_item_tit {
              font-weight: bold;
              font-size: 16px;
              color: #333333;
              margin-top: 28px;
            }
            .item {
              overflow: hidden;
              span {
                cursor: pointer;
                margin-top: 10px;
                margin-right: 16px;
                font-size: 12px;
                line-height: 12px;
                color: #666666;
              }
            }
          }
        }
        .ify_mo {
          cursor: pointer;
          width: 180px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          margin: 25px auto 0;
          background: #f9f9f9;
          border-radius: 5px;
          font-size: 16px;
          color: #0465ea;
        }
      }
      .ifynew {
        width: 880px;
        height: 100%;
        .ifynew_top {
          height: 350px;
          .int_left {
            width: 440px;
            height: 100%;
            .item {
              text-align: left;
              margin-bottom: 20px;
              &:hover {
                .text .text1 {
                  color: #0465ea;
                }
              }
              .itemimg {
                margin-right: 13px;
                width: 178px;
                img {
                  width: 100%;
                  height: 102px;
                }
              }
              .text {
                cursor: pointer;
                width: 266px;
                .text1 {
                  font-size: 16px;
                  font-weight: bold;
                  color: #333333;
                  margin-bottom: 14px;
                }
                .text2 {
                  font-size: 14px;
                  color: #666666;
                  line-height: 24px;
                }
              }
            }
          }
          .int_right {
            width: 420px;
            height: 100%;
            .item {
              text-align: left;
              margin-bottom: 20px;
              &:hover {
                .text .text1 {
                  color: #0465ea;
                }
              }
              .time {
                width: 100px;
                height: 102px;
                text-align: center;
                background-color: #f1f1f1;
                padding-top: 20px;
                margin-right: 13px;
                .time1 {
                  font-size: 40px;
                  color: #4d4d4d;
                  line-height: 32px;
                }
                .time2 {
                  margin-top: 10px;
                  font-size: 20px;
                  color: #4d4d4d;
                  line-height: 20px;
                }
              }
              .text {
                cursor: pointer;
                width: 266px;
                font-size: 14px;
                color: #666666;
                line-height: 24px;
              }
            }
          }
        }
        .ifynew_bottom {
          margin-top: 20px;
          padding: 20px 23px;
          background-color: #fff;
          align-items: flex-start;
          .inb_l {
            width: 405px;
            .inb_llist {
              padding-left: 18px;
              li {
                cursor: pointer;
                list-style: disc;
                font-size: 16px;
                color: #666666;
                &:hover {
                  color: #888;
                }
                margin-top: 14px;
              }
            }
          }
          .inb_r {
            width: 396px;
            .inb_c {
              margin-top: 30px;
            }
          }
        }
      }
    }
  }
}
</style>